// TESTIMONIAL VIDEO CAROUSEL (sections/video-testimonial-carousel.liquid)
// Swiper is only loaded by that section, so bail out everywhere else.
(function () {
  const container = document.querySelector('.swiperr-container');
  if (!container || typeof window.Swiper === 'undefined') return;

  new Swiper(container, {
    slidesPerView: 2,
    slidesPerGroup: 1,
    centeredSlides: false,
    spaceBetween: 10,
    loop: true,
    touchRatio: 1,
    resistanceRatio: 0.85,
    freeMode: false,
    watchOverflow: true,
    navigation: {
      nextEl: '.custom-next',
      prevEl: '.custom-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 20,
        loop: false,
      },
    },
  });

  const videos = container.querySelectorAll('.swiper-slide video');
  const setIcon = (video, visible) => {
    const icon = video.nextElementSibling;
    if (icon) icon.style.display = visible ? 'flex' : 'none';
  };
  const toggle = (video) => {
    videos.forEach((v) => {
      if (v !== video) {
        v.pause();
        setIcon(v, true);
      }
    });
    if (video.paused) {
      video.play();
      setIcon(video, false);
    } else {
      video.pause();
      setIcon(video, true);
    }
  };

  videos.forEach((video) => {
    video.addEventListener('click', () => toggle(video));
    video.addEventListener('ended', () => setIcon(video, true));
  });

  container.querySelectorAll('.play-icon').forEach((icon) => {
    icon.addEventListener('click', (event) => {
      const video = event.target.closest('.swiper-slide')?.querySelector('video');
      if (video) toggle(video);
    });
  });
  // Prev/next buttons are wired through the `navigation` option above.
})();
